import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "/admin/email", label: "Overview", end: true },
  { to: "/admin/email/subscribers", label: "Subscribers" },
  { to: "/admin/email/tags", label: "Tags & Segments" },
  { to: "/admin/email/campaigns", label: "Campaigns" },
  { to: "/admin/email/autoresponder", label: "Autoresponder" },
  { to: "/admin/email/settings", label: "Email Settings" },
];

export default function EmailLayout() {
  return (
    <div data-testid="email-marketing-shell">
      <div className="px-6 md:px-10 pt-9 md:pt-12">
        <h1 className="display text-[32px] md:text-[40px] leading-tight text-charcoal">
          Email Marketing
        </h1>
        <p className="text-[14.5px] font-light text-[#6A665F] mt-2.5 max-w-2xl leading-relaxed">
          Subscribers, consent records, tags, campaigns and the welcome autoresponder. Everything is
          stored in this website's own database.
        </p>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 border-b border-line mt-7">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`email-tab-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `pb-3 -mb-px text-[13px] tracking-[0.1em] uppercase transition-colors border-b-2 ${
                  isActive
                    ? "text-charcoal border-sage"
                    : "text-[#8A867F] border-transparent hover:text-charcoal"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="px-6 md:px-10 py-8 md:py-10">
        <Outlet />
      </div>
    </div>
  );
}

export const Card = ({ title, children, testid }) => (
  <div className="bg-white border border-line px-6 py-7" data-testid={testid}>
    {title && <div className="text-[10px] tracking-[0.2em] uppercase text-sage mb-5">{title}</div>}
    {children}
  </div>
);

export const Field = ({ label, children, hint }) => (
  <label className="block mb-5">
    <span className="block text-[11px] tracking-[0.14em] uppercase text-[#6E6A63] mb-2">{label}</span>
    {children}
    {hint && <span className="block text-[12px] font-light text-[#8A867F] mt-1.5">{hint}</span>}
  </label>
);

export const inputClass =
  "w-full bg-white border border-line px-3.5 py-2.5 text-[14px] font-light text-charcoal focus:outline-none focus:border-sage transition-colors";

export const Toggle = ({ checked, onChange, label, description, testid }) => (
  <label className="flex items-start gap-3 py-3 cursor-pointer">
    <input
      type="checkbox"
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid={testid}
      className="mt-[3px] h-4 w-4 accent-[#7a8b73]"
    />
    <span>
      <span className="block text-[14px] text-charcoal">{label}</span>
      {description && (
        <span className="block text-[12.5px] font-light text-[#8A867F] mt-0.5 leading-relaxed">
          {description}
        </span>
      )}
    </span>
  </label>
);

export const btn =
  "px-5 py-2.5 bg-sage text-white text-[11.5px] tracking-[0.14em] uppercase hover:bg-sage-dark transition-colors disabled:opacity-60";
export const btnGhost =
  "px-5 py-2.5 border border-line text-[11.5px] tracking-[0.14em] uppercase text-[#5A5A5A] hover:border-sage hover:text-charcoal transition-colors disabled:opacity-60";
